(function () {
  var ROOT_SELECTOR = '[data-wk-wishlist-page]';

  function ready() {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function check() {
        var wk = window.WishlistKing;
        if (wk && wk._apis && wk._apis.wishlist) return resolve(wk);
        if (Date.now() - start > 10000) return reject(new Error('WishlistKing not loaded'));
        setTimeout(check, 100);
      })();
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      try { return Shopify.formatMoney(cents, window.theme.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function renderPrice(product) {
    var min = product.price_min;
    var max = product.price_max;
    var compareMin = product.compare_at_price_min;
    var html = '';
    if (product.price_varies && min !== max) {
      html += '<span class="wishlist-page-card__price-from">From </span>' + formatMoney(min);
    } else {
      html += formatMoney(min);
    }
    if (compareMin && compareMin > min) {
      html += ' <s class="wishlist-page-card__price-compare">' + formatMoney(compareMin) + '</s>';
    }
    return html;
  }

  function buildCard(template, item) {
    var node = template.content.cloneNode(true);
    var product = item.product || {};
    var url = product.url || '/products/' + product.handle;
    var img = node.querySelector('[data-wk-image]');
    var title = node.querySelector('[data-wk-title]');
    var price = node.querySelector('[data-wk-price]');
    var removeBtn = node.querySelector('[data-wk-remove]');
    node.querySelectorAll('[data-wk-link]').forEach(function (a) { a.setAttribute('href', url); });
    if (product.featured_image) {
      img.setAttribute('src', product.featured_image);
      img.setAttribute('alt', product.title || '');
    } else {
      img.remove();
    }
    if (title) title.textContent = product.title || '';
    if (price) price.innerHTML = renderPrice(product);
    if (removeBtn) {
      removeBtn.dataset.wishlistItemId = item.id;
      removeBtn.setAttribute('aria-label', 'Remove ' + (product.title || '') + ' from wishlist');
    }
    return node;
  }

  function init(root, wk) {
    var grid = root.querySelector('[data-wk-grid]');
    var emptyEl = root.querySelector('[data-wk-empty]');
    var loadingEl = root.querySelector('[data-wk-loading]');
    // Look up the card template on the whole document — Shopify section rendering
    // can serialize a <template> child of the <section> as a sibling of </section>
    // in some pipelines, so a root-scoped query is unreliable here.
    var template = root.querySelector('[data-wk-card-template]') || document.querySelector('[data-wk-card-template]');
    if (!template) {
      console.warn('[wishlist-page] card template element not found on page');
      return;
    }

    function render(items) {
      loadingEl.hidden = true;
      grid.innerHTML = '';
      if (!items.length) {
        grid.hidden = true;
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;
      grid.hidden = false;
      var frag = document.createDocumentFragment();
      items.forEach(function (item) { frag.appendChild(buildCard(template, item)); });
      grid.appendChild(frag);
    }

    function refresh() {
      // Bust WK's internal wishlist cache before fetching — by default loadWishlist uses
      // `public, max-age=60, stale-while-revalidate=86400`, so after a removeItem the
      // cached response still contains the just-removed item. Re-rendering from that
      // stale response keeps the deleted card in the DOM, and the user's next remove
      // click 404s because the server already deleted that item.
      var clearCachePromise = wk._state && typeof wk._state.clearCache === 'function'
        ? Promise.resolve(wk._state.clearCache(true)).catch(function () {})
        : Promise.resolve();
      return clearCachePromise.then(function () {
        return wk._apis.wishlist.loadWishlist({ wishlistId: 'mine', cacheStrategy: 'no-store' });
      }).then(function (res) {
        render(res.wishlist.items || []);
      }).catch(function (err) {
        console.error('[wishlist-page] load failed', err);
        loadingEl.textContent = 'Could not load wishlist.';
      });
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wk-remove]');
      if (!btn) return;
      var id = btn.dataset.wishlistItemId;
      if (!id) return;
      btn.disabled = true;
      // Same reason as in wishlist-button.js: wk.removeWishlistItem (the state-machine
      // wrapper) sets an "E" lock that's only cleared by an observeWishlist subscriber.
      // The theme's section doesn't subscribe (it renders its own DOM via the
      // data-wk-* hooks), so after the first remove the lock sticks and every
      // subsequent remove click silently no-ops. Use the low-level API instead.
      wk._apis.wishlist.removeItem({ wishlistId: 'mine', wishlistItemId: id }).catch(function (err) {
        console.error('[wishlist-page] remove failed', err);
      }).then(function () { btn.disabled = false; refresh(); });
    });

    if (wk.events && typeof wk.events.subscribe === 'function') {
      ['wishlist:add:success', 'wishlist:remove:success', 'wishlist:clear:success'].forEach(function (name) {
        try { wk.events.subscribe(name, refresh); } catch (e) {}
      });
    }

    refresh();
  }

  function start() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    ready().then(function (wk) { init(root, wk); }).catch(function (err) {
      console.warn('[wishlist-page]', err && err.message);
      var loadingEl = root.querySelector('[data-wk-loading]');
      if (loadingEl) loadingEl.textContent = 'Wishlist app is not available.';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
